<template>
    <div class="palettes-view with-fixed-section">
        <add-palette-button></add-palette-button>
        <palettes-collection></palettes-collection>
    </div>
</template>

<script>
    import BaseView           from "../../../App/Views/BaseView";
    import PalettesCollection from "./Components/Palette/PalettesCollection";
    import AddPaletteButton   from "./Components/Palette/AddPaletteButton";
    import Transition         from "../../../Lib/Objects/Transition";

    export default {
        components: { AddPaletteButton, PalettesCollection },
        extends   : BaseView,

        data() {
            return {
                title : "Palettes",
            }
        },

        methods: {
            
        },

        mounted() {
            new Transition('.add-palette', 1).fadeIn();
            new Transition('.vertical > .smooth-dnd-draggable-wrapper', 0.5).staggerFadeIn(0.1);
        },

        beforeDestroy() {
            new Transition('.add-palette', 1).fadeOut();
            new Transition('.palettes-list', 1).fadeOut();
        }
    }

</script>